// extracted by mini-css-extract-plugin
export var colorSquare = "_uj-0";
export var danger = "_uj-5";
export var lightPink = "_uj-8";
export var neutralBlue = "_uj-7";
export var neutralYellow = "_uj-6";
export var normal = "_uj-1";
export var primary = "_uj-2";
export var primaryLight = "_uj-3";
export var solidBlack = "_uj-g";
export var solidGreen = "_uj-b";
export var solidLightBlue = "_uj-d";
export var solidNavy = "_uj-c";
export var solidOrange = "_uj-f";
export var solidPink = "_uj-e";
export var solidRed = "_uj-9";
export var solidYellow = "_uj-a";
export var success = "_uj-4";